import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import Util from '../../../util'

const state = {
  token: localStorage.getItem('token'),
  user: Util.getUser(),
  access : JSON.parse(localStorage.getItem("access") || '[]')
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js